import _implicitStylesheets from "./moreResourcesSection.css";
import _implicitScopedStylesheets from "./moreResourcesSection.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _wdsLink from "wds/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="section__header${0}"${2}><h4 type-style="display-8"${3}>${"t2"}</h4><div class="bar${0}"${2}></div></div>`;
const $fragment2 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment3 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment4 = parseFragment`<div class="divider${0}"${2}></div>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, b: api_bind, c: api_custom_element, h: api_element, i: api_iterator, f: api_flatten} = $api;
  const {_m0} = $ctx;
  return api_flatten([api_static_fragment($fragment1, 1, [api_static_part(2, null, api_dynamic_text($cmp.sectionTitle))]), api_iterator($cmp.resourceSection.resources, function (resource) {
    return api_element("div", {
      key: api_key(2, resource.id),
      on: {
        "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
      }
    }, [api_custom_element("wds-link", _wdsLink, {
      props: {
        "name": resource.caption
      },
      key: 3
    }, [resource.shouldDownload ? api_element("a", {
      attrs: {
        "href": resource.url,
        "target": "_blank",
        "download": resource.fileName
      },
      key: 4
    }, [api_custom_element("ads-icon", _adsIcon, {
      props: {
        "size": "small",
        "symbol": resource.icon
      },
      key: 5
    }), api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text(resource.caption))])]) : null, !resource.shouldDownload ? api_element("a", {
      attrs: {
        "href": resource.url,
        "target": "_blank"
      },
      key: 8
    }, [api_custom_element("ads-icon", _adsIcon, {
      props: {
        "size": "small",
        "symbol": resource.icon
      },
      key: 9
    }), api_static_fragment($fragment3, 11, [api_static_part(1, null, api_dynamic_text(resource.caption))])]) : null]), api_static_fragment($fragment4, 13)]);
  })]);
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4ail7e7gc9n";
tmpl.legacyStylesheetToken = "undefined-_moreResourcesSection";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
